var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-gy-9 flex-row flex-align-center"},[_vm._v("\n\t"+_vm._s(_vm.row.message_name)+"\n\t"),(_vm.row.isException)?_c('rdTag',{staticClass:"ml-6",attrs:{"tagType":"warning"}},[_vm._v("异常提醒")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }